import {Component} from '@angular/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {ActivatedRoute} from '@angular/router';

import {Tabs, TabsModule} from 'primeng/tabs';
import {PanelModule} from 'primeng/panel';
import {TableModule} from 'primeng/table';


import {PagesScannedComponent} from './pages-scanned/pages-scanned.component';
import {ThemeDetailsComponent} from './theme-details/theme-details.component';
import {PluginsDetailsComponent} from './plugins-details/plugins-details.component';
import {AccessibilityDetailsComponent} from './accessibility-details/accessibility-details.component';
import {LighthouseDetailsComponent} from './lighthouse-details/lighthouse-details.component';
import {WordpressDetailsComponent} from './wordpress-details/wordpress-details.component';
import {SecurityCheckComponent} from './security-check/security-check.component';
import {HostingDetailsComponent} from './hosting-details/hosting-details.component';
import {CruxDetailsComponent} from './crux-details/crux-details.component';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-test-detail',
  standalone: true,
  templateUrl: './test-details.component.html',
  styleUrls: ['./test-details.component.css'],
  imports: [
    CommonModule,
    HttpClientModule,
    TabsModule,
    PanelModule,
    TableModule,
    PagesScannedComponent,
    ThemeDetailsComponent,
    PluginsDetailsComponent,
    AccessibilityDetailsComponent,
    LighthouseDetailsComponent,
    WordpressDetailsComponent,
    SecurityCheckComponent,
    HostingDetailsComponent,
    CruxDetailsComponent
  ],

})

export class TestDetailsComponent {
  jsonData: any;
  testId: string;
  pluginsData: any;
  pagesScannedData: any;
  accessibilityData: any;
  lighthouseData: any;
  chromeUXData: any;
  wordpressData: any;
  hostingData: any;
  themesData: any;
  securityData: any;

  constructor(private http: HttpClient, route: ActivatedRoute) {
    this.testId = route.snapshot.params['id'];
  }

  getFeedbackUrl() {
    if (!this.testId) {
      return '';
    }
    const baseUrl = "https://docs.google.com/forms/d/e/1FAIpQLScXvvGvjioum3_SOdF730y6o9yTwMIS7Bs4uzmqGzK-yxKnGw/viewform?usp=pp_url&entry.2087708398=";
    return `${baseUrl}${this.testId}`;
  }

  ngOnInit(): void {

    // get the ID form the :id in route
    this.http.get(`${environment.apiUrl}/reports/summary/id/${this.testId}/results.json`)
      .subscribe(data => {

        this.jsonData = data;

        console.log("this.jsonData.PerformanceTest?.PageSpeedInsightsTest")
        // console.log(data);
        console.log('tomepajk');
        console.log(this.jsonData.PerformanceTest?.PageSpeedInsightsTest)

        this.wordpressData = this.jsonData.SiteScanner?.wordpress;
        this.pluginsData = this.jsonData.SiteScanner?.plugins;
        this.hostingData = this.jsonData.SiteScanner?.hosting;
        this.themesData = this.jsonData.SiteScanner?.themes;
        this.pagesScannedData = this.jsonData.sitemap;
        this.accessibilityData = this.jsonData.AccessibilityTest;
        this.lighthouseData = this.jsonData.PerformanceTest?.PageSpeedInsightsTest;
        this.chromeUXData = this.jsonData.PerformanceTest?.CruxDataCheck;
        this.securityData = this.jsonData.SecurityTest;
        this.hostingData = this.jsonData.SiteScanner?.hosting;
      });
  }
}
